/**
 * Language Store (Zustand)
 * Hanterar språkval och översättningar
 */

import { create } from 'zustand';
import i18n from '../i18n/config';

export type Language = 'sv' | 'en' | 'lt';

interface LanguageState {
  language: Language;
  setLanguage: (lang: Language) => void;
  initializeLanguage: (lang: Language) => void;
}

export const useLanguageStore = create<LanguageState>((set) => ({
  language: (localStorage.getItem('i18nextLng') as Language) || 'sv',

  setLanguage: async (lang: Language) => {
    try {
      await i18n.changeLanguage(lang);
      localStorage.setItem('i18nextLng', lang);
      set({ language: lang });
      // Force re-render av alla komponenter som använder useTranslation
      // react-i18next triggar automatiskt re-renders via sin hook
    } catch (error) {
      console.error('Failed to change language:', error);
    }
  },

  initializeLanguage: async (lang: Language) => {
    // Används när användaren loggar in för att sätta språk från user.preferred_language
    try {
      console.log('Initializing language to:', lang);
      await i18n.changeLanguage(lang);
      localStorage.setItem('i18nextLng', lang);
      set({ language: lang });
      console.log('Language initialized successfully. Current i18n language:', i18n.language);
    } catch (error) {
      console.error('Failed to initialize language:', error);
    }
  },
}));

// Re-export useTranslation från react-i18next för enkel användning
export { useTranslation } from 'react-i18next';

// Hook för att få språkval och ändra språk
export const useLanguage = () => {
  const language = useLanguageStore((state) => state.language);
  const setLanguage = useLanguageStore((state) => state.setLanguage);
  const initializeLanguage = useLanguageStore((state) => state.initializeLanguage);
  
  return { language, setLanguage, initializeLanguage };
};
